import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Card, Typography, Button, Spin, message } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { documentsAPI } from '../services/api';

const { Title, Paragraph } = Typography;

const DocumentView: React.FC = () => {
  const { documentKey } = useParams<{ documentKey: string }>();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [document, setDocument] = useState<any>(null);

  useEffect(() => {
    // Определяем ключ документа на основе URL
    const currentPath = window.location.pathname;
    let docKey = documentKey;
    
    if (currentPath === '/terms') {
      docKey = 'terms_of_service';
    } else if (currentPath === '/privacy') {
      docKey = 'privacy_policy';
    }
    
    if (docKey) {
      loadDocument(docKey);
    }
  }, [documentKey]);

  const loadDocument = async (docKey: string) => {
    setLoading(true);
    try {
      // Маппинг старых ключей на новые
      const keyMap: { [key: string]: string } = {
        'terms': 'terms_of_service',
        'privacy': 'privacy_policy'
      };
      const actualKey = keyMap[docKey] || docKey;
      
      const versions = await documentsAPI.getDocumentVersions(actualKey);
      if (versions && versions.length > 0) {
        // Берем активную версию (первую в списке)
        setDocument(versions[0]);
      } else {
        message.error('Документ не найден');
      }
    } catch (error) {
      console.error('Error loading document:', error);
      message.error('Ошибка загрузки документа');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh' 
      }}>
        <Spin size="large" />
      </div>
    );
  }

  if (!document) {
    return (
      <div style={{ padding: '20px', textAlign: 'center' }}>
        <Title level={3}>Документ не найден</Title>
        <Button type="primary" onClick={() => navigate('/register')}>
          Вернуться к регистрации
        </Button>
      </div>
    );
  }

  return (
    <div style={{ padding: '20px', maxWidth: '800px', margin: '0 auto' }}>
      <Button 
        icon={<ArrowLeftOutlined />} 
        onClick={() => navigate('/')}
        style={{ marginBottom: '20px' }}
      >
        Вернуться на главную
      </Button>
      
      <Card>
        <Title level={2}>{document.title}</Title>
        <Paragraph type="secondary">
          Версия: {document.version} | 
          Последнее обновление: {new Date(document.createdAt).toLocaleString('ru')}
        </Paragraph>
        
        <div 
          style={{ 
            marginTop: '20px',
            padding: '20px',
            background: '#f5f5f5',
            borderRadius: '8px',
            lineHeight: '1.8',
            fontSize: '16px'
          }}
          dangerouslySetInnerHTML={{ __html: document.content }}
        />
      </Card>
    </div>
  );
};

export default DocumentView;
